"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.STYLE_CONFIG = exports.PRICE_CONFIG = exports.JOURNEY_TYPE = exports.ICON = exports.DEFAULT_VERSION = exports.CTA_VERSION = void 0;
var JOURNEY_TYPE = {
  depart: 'departFlight',
  return: 'returnFlight'
};
exports.JOURNEY_TYPE = JOURNEY_TYPE;
var TRANSLATION = {
  depart: 'Depart',
  return: 'Return',
  guest: "{0} guests",
  notAvailable: 'Not Available',
  included: 'Included',
  upgraded: 'Upgraded to',
  select: 'Select',
  continue: 'Continue'
};
exports.TRANSLATION = TRANSLATION;
var PRICE_CONFIG = {
  priceTemplate: 'DEFAULT',
  decimalType: 'CEIL',
  pricePrefix: 'ADD'
};
exports.PRICE_CONFIG = PRICE_CONFIG;
var STYLE_CONFIG = {
  neutral: 'neutral',
  textSmall: 'textSmall',
  titleSmall: 'titleSmall',
  secondary: 'secondary',
  green: 'darkgreen',
  greyDark: 'greyDark',
  titleNormal: 'titleNormal',
  small: 'small',
  default: 'default'
};
exports.STYLE_CONFIG = STYLE_CONFIG;
var ICON = {
  AddCircleIcon: 'AddCircle',
  CheckCircleIcon: 'CheckCircleIcon',
  DotIcon: 'DotIcon',
  DisableCheckIcon: 'DisableCheckIcon'
};
exports.ICON = ICON;
var CTA_VERSION = {
  V1: 'V1',
  V2: 'V2'
};
exports.CTA_VERSION = CTA_VERSION;
var DEFAULT_VERSION = CTA_VERSION.V1;
exports.DEFAULT_VERSION = DEFAULT_VERSION;